<template>
  <div class="h-100">
    <WebLayout v-if="$route.meta.layout === 'web-layout' || $route.meta.layout === undefined">
      <router-view/>
    </WebLayout>
  </div>
  <FooterHome/>
</template>

<style lang="scss" rel="stylesheet/scss"></style>

<script>

import WebLayout from "@/views/layouts/WebLayout";
import FooterHome from "@/partials/FooterHome";

export default {
  components: {
    FooterHome,
    WebLayout,
  },

  data() {
    return {
      checkAuth: false
    };
  },

  created() {
    fetch('https://api.sethotels.net/api/analytics/1f92ec98-34b0-4368-9cd8-3072e74e4682', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({url: window.location.href, referrer_url: document.referrer, title: document.title})
    });
  }
}
</script>
